import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect } from "react";
import parse from "html-react-parser";
import { useParams } from "react-router-dom";
import "./SingleArticle.scss";
import GoogleAdSense from "../../GoogleAdSense/GoogleAdSense";
import Helmetcomponent from "../Helmet/helmetcomponent";
import altProfile from "../../img/altprofile.jpg";
import { useNavigate } from "react-router-dom";
import httpService from "../../common/http.service";


const SingleArticle = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { id } = useParams();
  const navigate = useNavigate();
  // const REACT_APP_DEV_ENDPOINT = process.env.REACT_APP_DEV_ENDPOINT;REACT_APP_ENDPOINT
  const REACT_APP_ENDPOINT = process.env.REACT_APP_ENDPOINT;
  const url = `article/single/${id}`;
  const DEFAULT_IMAGE = `${process.env.REACT_APP_IMG_URL}images/files-test/1734705843913.jpeg`;


  const { data: article } = useQuery([`articleList`, id], () =>
    httpService.get(url).then((data) => data.data.data)
  );

  function removeBrTags(html) {
    return html.replace(/<br\s*[/]?>/gi, "");
  }


  const title = article?.name;
  const fontStyles = {
    "ql-font-arial": { fontFamily: "Arial, sans-serif" },
    "ql-font-onest": { fontFamily: "Onest, sans-serif" },
  };

  const handleCategoryClick = (categoryId) => {
    window.scrollTo(0, 0);
    navigate(`/article/${categoryId}`);
  };

  return (
    <>

      <div
        // style={{ paddingTop: "2.3%", margin: "20px" }}
        // className="w-75 mx-auto"
        className="container "
        style={{ maxWidth: "2000px" }}
      >
        <Helmetcomponent index="SingleArticle" path={id} data={title} />
        {article && (
          <div>
            <div className="relative w-full" style={{ paddingTop: "50%" }}>
              <img
                src={article?.image || DEFAULT_IMAGE}
                alt=""
                className="absolute top-0 left-0 w-full h-full object-cover"
              />
              {/* Gradient Overlay */}
              <div className="absolute bottom-0 left-0 w-full h-3/4 bg-gradient-to-t from-black to-transparent"></div>

              {/* Title Over Image */}
              <div className="absolute bottom-10 left-8 text-white font-poppins">
                <h3
                  className="text-xl md:text-2xl font-semibold"
                >
                  {article?.name}
                </h3>
                <div className="flex  ">
                  <div className="">
                    <img className="h-14 w-14 mr-3 rounded-full" src={article?.authorImage || altProfile} alt="" />
                  </div>
                  <div className="flex flex-col justify-center items-start">
                    <div className="flex flex-col mt-1">
                      <span className="">
                        {article.authorName || "Author"}
                      </span>
                    </div>
                    {article?.publishDate && (
                      <span className="text-sm mt-1 block text-white ">
                        {new Date(article.publishDate).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* {article?.publishDate && (
              <div className="card-body py-2 flex justify-center items-center">
                <h5
                  className="card-title"
                  style={{ color: "#f16334", fontWeight: 600 }}
                >
                  <div className="flex justify-center items-center mt-4 text-lg">
                    <div className="">
                      <img className="h-14 w-14 mr-3 rounded-full" src={article?.authorImage || altProfile} alt="" />
                    </div>
                    <div className="flex flex-col">
                      <span className="-mt-1">
                         {article.authorName || "Author"}
                      </span>
                      <span className="-mt-1">
                        {new Date(article.publishDate).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
                      </span>
                    </div>
                  </div>
                </h5>
              </div>
            )} */}

            <div className="my-3 shadow-lg w-100 bg-[#FFEFEE] rounded-xl border-2 border-[#FF695F]">
              {/* <h5
                className="card-title"
                style={{ color: "#f16334", fontWeight: 600 }}
              >
                Description
              </h5> */}

              <div className="description-container m-5">
                {article?.descriptionBlocks?.length==0 && <span>{parse(removeBrTags(article?.description.trim()))}</span>}
              </div>

              <div className="description-container m-5 flex flex-col">
                {article?.descriptionBlocks?.map((block, index) => {
                  if (block.adType && block.adType !== "none" && block.adUrl) {
                    return (
                      <div
                        key={`ad-${block.id || index}-${crypto.randomUUID()}`}
                        className="flex justify-center my-4"
                      >
                        <a
                          href={block.adUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block bg-white w-1/2 no-underline relative rounded-xl p-2 border border-gray-500"
                        >
                          <div className="flex flex-col justify-center items-center relative">
                            <h4 className="absolute top-1 right-1 text-[#f16334] font-bold">Ad</h4>
                            <img
                              src={block.image}
                              alt="Advertisement"
                              className="rounded cursor-pointer h-44 w-44 p-2"
                            />
                            <div className="ml-4 flex flex-col p-2 w-full relative">
                              <h5 className="text-lg text-black mt-4">
                                {block?.shopItem?.name
                                  ? block.shopItem.name.length > 15
                                    ? block.shopItem.name.substring(0, 60) + "..."
                                    : block.shopItem.name
                                  : ""}
                              </h5>
                              <div className="flex items-center justify-center">
                                <button className="px-4 py-2 bg-[#f16334] text-white rounded-3xl hover:bg-[#d6522d] w-32 mt-6">
                                  Buy Now
                                </button>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    );
                  }

                  return block.description ? (
                    <div
                      key={`desc-${block.id || index}-${crypto.randomUUID()}`}
                      className="my-2"
                    >
                      {parse(block.description.trim(), {
                        replace: (domNode) => {
                          if (domNode.name === "span" && domNode.attribs?.class) {
                            const fontClass = domNode.attribs.class;
                            const style = fontStyles[fontClass] || {};
                            return (
                              <span
                                key={`span-${block.id || index}-${crypto.randomUUID()}`}
                                style={style}
                              >
                                {domNode.children[0]?.data}
                              </span>
                            );
                          }
                          if (domNode.name === "ul") {
                            domNode.attribs = {
                              ...domNode.attribs,
                              class: `${domNode.attribs?.class || ""} list-disc pl-6`.trim(),
                            };
                          }
                          if (domNode.name === "li") {
                            domNode.attribs = {
                              ...domNode.attribs,
                              class: `${domNode.attribs?.class || ""} mb-2`.trim(),
                            };
                          }
                          if (domNode.name === "ol") {
                            domNode.attribs = {
                              ...domNode.attribs,
                              class: `${domNode.attribs?.class || ""} list-decimal pl-6`.trim(),
                            };
                          }
                          
                          return undefined;
                        },
                      })}
                    </div>
                  ) : null;
                })}
              </div>
            </div>
          </div>
        )}
        <div className=" g-3 mb-3 mt-5 flex flex-col items-center">
          {article?.relatedArticles && article.relatedArticles.length > 0 && (
            <>
              <h3 className="text-center text-[#f16334] font-semibold w-full">Related Articles</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4  justify-items-center gap-4">
                    {article.relatedArticles.map((related, index) => (
                        <div
                            key={index}
                            onClick={() => handleCategoryClick(related?._id)}
                            className="bg-white mt-4 w-72 rounded-xl shadow-md overflow-hidden border border-gray-200 hover:shadow-xl transition duration-300 cursor-pointer"
                        >
                            <div className="h-44 w-full overflow-hidden">
                                <img
                                    alt="article"
                                    src={
                                      related.image || DEFAULT_IMAGE
                                    }
                                    className="object-cover w-full h-full"
                                />
                            </div>
                            <div className="relative p-4 h-32 bg-white shadow rounded-md">
                            <h2 className="text-lg font-semibold text-gray-800">
                                    {(related.name?.length > 40 ? related.name.slice(0, 40) + "..." : related.name) || "Article Title"}
                                </h2>
                                {/* Description if needed */}
                                {/* <p className="text-sm text-gray-500 mt-1">
                                    {(article.description?.length > 20
                                        ? article.description.slice(0, 20) + "..."
                                        : article.description) || "Lorem Ipsum is simply..."}
                                </p> */}
                                <p className="text-sm text-red-500 font-medium absolute bottom-0 left-6">
                                    Read More
                                </p>
                            </div>
                        </div>
                    ))}
            </div>
            </>
          )}
        </div>
        <GoogleAdSense />
      </div>
    </>
  );
};



export default SingleArticle;
